import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { useUserContext } from '../../hooks/userHook';
import { getAuthData, getUserData } from '../../utils/wordpress';

export type LoginPropType = {
  onSuccessCallback?: () => any | void;
  [x: string]: any;
}

export default function Login(props: LoginPropType) {
  const { user, setUser, logoutUser } = useUserContext();

  const [login, setLogin] = useState<string | null>(null);
  const [password, setPassword] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const onSuccessCallback = () => {
    if (props.onSuccessCallback) {
      props.onSuccessCallback();
    }
  };

  const submitHandler = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    let userDetailedData = null;

    const authData = await getAuthData(login || '', password || '');

    if (!authData.data) {
      userDetailedData = {
        nickname: authData.user_display_name,
        ...await getUserData(authData.token, authData.user_email),
      };

      setError(null);
      onSuccessCallback();
    } else {
      setError(authData.message);
    }

    setUser(userDetailedData);
    setLogin(null);
    setPassword(null);
    setLoading(false);

  };

  const disabled = !!user || loading;

  return (
    <div id="schedule-login-container" className="row">
      <div className="col-12 mb-4">
        {
          user
            ? (
              <div className="d-grid gap-2 mt-4">
                <Button
                  size="lg"
                  variant="primary"
                  type="button"
                  className="mt-4 d-flex justify-content-center align-items-center"
                  onClick={() => logoutUser()}
                >
                  Logout
                </Button>
              </div>
            )
            : (
              <Form onSubmit={submitHandler} className="mt-2">
                <Form.Group className="mb-3" controlId="login">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Username"
                    value={login || ''}
                    onChange={(event) => setLogin(event.target.value)}
                    required
                    disabled={disabled}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={password || ''}
                    onChange={(event) => setPassword(event.target.value)}
                    required
                    disabled={disabled}
                  />
                </Form.Group>

                <Button
                  size="lg"
                  variant="primary"
                  type="submit"
                  className="mt-4 d-flex justify-content-center align-items-center"
                  disabled={disabled}
                >
                  <span>Login</span>
                  {loading && <Spinner animation="border" variant="light" size="sm" className="ms-2" />}
                </Button>
              </Form>
            )
        }

        {
          error && (
            <div className="alert alert-danger mt-3" role="alert">
              {<div dangerouslySetInnerHTML={{ __html: error || '' }} />}
            </div>
          )
        }
      </div>
    </div >
  );
}